<template>
	<div class="search-result-component">
        <!-- 搜索结果列表 -->
        <p class="search-info-des" v-show="curList.length">
            已为您找到<span>{{postText}}</span>相关的信息有<span>{{curList.length}}</span>条
        </p>
        <transition-group tag="ul" name="listItemActive" mode="out-in" :key="curList.length">
		<!-- <ul :key="curList.length" v-if="curList.length"> -->
            <li v-for="item in showList" :key="item.id" :data-id="item.id">
                <a class="list-img" v-if="item.src != null" :href="item.src">
                    <img :src="item.img" :alt="item.title">
                </a>
                <a class="list-img" v-else href="javascript:void(0)" onclick="zixun()">
                    <img :src="item.img" :alt="item.title">
                </a>
                <div class="list-info">
                    <div class="list-info-left">
                        <h3>{{ item.title }}</h3>
                        <p>咨询人数：<span>2334</span></p>
                    </div>
                    <div class="list-info-right">
                        <a v-if="item.src != null" :href="item.src">查看<br />详情</a>
                        <a v-else href="javascript:void(0)" onclick=zixun()>免费<br />咨询</a>
                    </div>
                </div>
            </li>
        <!-- </ul> -->
        </transition-group>
        <a ref="allMore" href="javascript:void(0)" :class="['show-more-item',{'show-moreEnd-item':isMore}]" v-show="curList.length > num" @click="showAllListData">查看更多</a>
        <!-- 搜索结果为空 -->
        <div class="search-empty-show" v-show="curListLengthIsEmpty">
            <p>抱歉，没有找到跟<span v-cloak>{{postText}}</span>相关的内容</p>
            <p>试一试搜索其他创业项目吧！</p>
        </div>
	</div>
</template>
<script>
export default {
    name:'List',
    data(){
        return{
            list: [], // 所以数据
            curList: [], // 搜索到的数据
            showList: [], // 显示10条数据
            curListLengthIsEmpty: false,
            isMore: false,
            num: 8 // 搜索显示数量
        }
    },
    props:['postText'], // 接收父组件传递的来的搜索内容
    methods: {
        /* 本地获取数据 */
        getLocalDataByFetch(callBack){
            fetch('/assets/json/dqList.json')
                .then((res) => {
                    return res.json();
                })
                .then((data) => {
                    callBack && callBack(data);
                })
        },
        /* 过滤数据 得到特定数据类型 */
        filterDataType(data,dataType){
            for(var item of data){
                if(item['dataType'] == dataType){
                    return item.dataList;
                }
            }
        },
        getCurList(searchText){ // 根据搜索词获取当前数据
            var This = this;
            this.getLocalDataByFetch(function(data){
                This.list = This.filterDataType(data.fondData,'food');
                This.curList = This.list.filter((item)=>{
                    return item.des.indexOf(searchText) != -1
                })
            })
        },
        /* 随机获取数组中的数据*/
        getRandomArrayElements(arr, count) {
            var shuffled = arr.slice(0),
                i = arr.length,
                min = i - count,
                temp, index;
            while (i-- > min) {
                index = Math.floor((i + 1) * Math.random());
                temp = shuffled[index];
                shuffled[index] = shuffled[i];
                shuffled[i] = temp;
            }
            return shuffled.slice(min);
        },
        showAllListData() { // 显示所以搜索到的数据
            this.showList = this.curList;
        },
    },
    mounted() {
        this.curListLengthIsEmpty = false; // 一加载就 搜索结果为空 隐藏
    },
    watch:{
        postText(){ // 监听搜索内容
            // console.log(this.searchText == '');
            if(this.postText == ''){
                this.curList = [];
                this.showList = [];
                this.curListLengthIsEmpty = false;
            }else if(this.postText != ''){
                this.showList = [];
                this.getCurList(this.postText);
                setTimeout(()=>{
                    if( this.curList.length == 0 ){
                        this.curListLengthIsEmpty = true; // 搜索结果为空 隐藏
                    }else{
                        this.curListLengthIsEmpty = false;
                        if( this.curList.length > this.num ){
                            this.showList = this.getRandomArrayElements(this.curList,this.num); // 随机获取10条数据 显示10条数据
                        }else{
                            this.showList = this.curList;
                        }
                    }
                },500)
            }
        }
    },
    updated(){
        // 控制是否有更多搜索结果
        if( this.showList.length == this.curList.length ){
            this.$refs.allMore.innerHTML = "没有更多啦";
            this.isMore = true;
        }else{
            this.$refs.allMore.innerHTML = "查看更多";
            this.isMore = false;
        }
    }
}
</script>
<style lang="less" scoped>
@rem: 40rem;
@w100: 640/@rem;
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: @w/@rem;
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: @radius/@rem @radius/@rem @radius/@rem @radius/@rem;
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: @lineHeight/@rem;
    font-size: @fontSize/@rem;
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: @h/@rem;
        }
    }
}
// vue闪烁问题
[v-cloak] {
    display: none;
}
.search-result-component{
    .search-info-des{
        .linefont(30, 22, #000);
        span{
            .linefont(30, 22, #f13530);
        }
    }
    ul{
        .auto(610);
        &:extend(.justify);
        li{
            width: 295/@rem;
            margin-top: 16/@rem;
            .list-img{
                display: block;
                img {
                    width: 100%;
                    height: 195/@rem;
                }
            }
            .list-info{
                border: 1px solid #535353;
                border-top: none;
                border-radius: 0 0 6/@rem 6/@rem;
                &:extend(.justify);
                padding: 15/@rem 0;
                .list-info-left{
                    text-align: left;
                    text-indent: 10/@rem;
                    h3{
                        .linefont(30, 19, #000);
                    }
                    p{
                       .linefont(30, 19, #000);
                       span{
                           .linefont(30, 19, #f13530);
                       }
                    }
                }
                .list-info-right{
                    a{
                        display: block;
                        width: 66/@rem;
                        background: #f90403;
                        .linefont(22, 19, #fff);
                        padding: 10/@rem 0;
                        margin-right: 10/@rem;
                        position: relative;
                        &::before{
                            content: '';
                            width: 0;
                            height: 0;
                            border-top: 10/@rem solid transparent;
                            border-left: 17/@rem solid transparent;
                            border-bottom: 10/@rem solid transparent;
                            border-right: 17/@rem solid #f90403;
                            position: absolute;
                            left: -34/@rem;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
            }
        }
    }
}
.no-data-style{
    .linefont(60, 22, #eb6100);
    margin-top: 40/@rem;
    margin-bottom: 40/@rem;
}
// 【进入】动画效果
.listItemActive-enter-active{
    animation: bounce-in .5s;
}
// 【离开】动画效果
.listItemActive-leave-active{
    animation: bounce-in .5s reverse;
}
@keyframes bounce-in{
    0%{
        opacity: 0;
        transform: scale(.3) translateY(50%);
    }
    100%{
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}
.search-empty-show{
    p{
        .linefont(38, 25, #000);
        span{
            .linefont(38, 25, #e72b2e);
        }
    }
}
// 显示更多
.show-more-item {
    .auto(600);
    display: block;
    .linefont(60, 22, #fff);
    background: #ff6600;
    .radius(4);
    margin-top: 25/@rem;
    margin-bottom: 25/@rem;
}
.show-moreEnd-item{ // 数据加载完 没有更多的样式
    background: #eeeeee;
    color: #737373;
}
</style>